const municipalityData = {
    //Adams County
  Adams: {
    "Abbottstown Borough": {
    "Electric": "Med Ed (800-545-7741), Adams Electric Co-Operative (888-232-6732)",
    "Sewer": "Abbotstown/Paradise Joint Sewer Authority (717-259-9120)",
    "Water": "York Water Company (717-845-3601)",
    "Trash/Recycling": "Waste Connections (717-709-1700)",
    "Gas": "Private vendor"
  },
  "Arendtsville Borough": {
    "Gas": "Columbia Gas (1-888-460-4332)",
    "Electric": "Met-Ed (800-545-7741)",
    "Sewer": "Arendtsvill Borough (717-677-6009)",
    "Water": "Arendtsvill Borough (717-677-6009)",
    "Trash": "Waste Connections (717-709-1700)"
  },
  "Bendersville Borough": {
    "Water/Sewer": "Possum Valley Municipal Authority (717-677-8551)",
    "Electric": "Met-Ed (800-545-7741), Adams Electric Co-Operative (888-232-6732)",
    "Trash/Recycling": "Waste Connection (717-709-1700)",
    "Gas": "Columbia Gas (1-888-460-4332)"
  },
  "Berwick Township": {
    "Sewer": "Abbotstown/Paradise Joint Sewer Authority (call township to verify)",
    "Water": "Well or if public, does not service all of Berwick Township, call township to verify (717-632-1829)",
    "Trash/Recycling": "Private vendor",
    "Gas": "Private vendor",
    "Electric": "Met-Ed"
  },
  "Biglerville Borough": {
    "Water/Sewer": "Biglerville Borough (717-677-8802)",
    "Electric": "Met-Ed (800-545-7741)",
    "Trash": "Waste Connections (717-709-1700)",
    "Gas": "Columbia Gas (1-888-460-4332)"
  },
  "Bonneauville Borough": {
    "Trash/Recycling": "Contact private vendor",
    "Water/Sewer": "Bonneauville Borough Municipal Authority (717-334-2662)",
    "Electric": "Met-Ed (800-545-7741), Adams Electric Co-Operative (888-232-6732)",
    "Gas": "Private vendor"
  },
  "Butler Township": {
    "Trash": "Waste Connections (717-709-1700)",
    "Water": "Well (if public, run through sewer bill through Biglerville Borough)",
    "Sewer": "Biglerville Borough",
    "Electric": "Met-Ed (800-545-7741), Adams Electric Co-Operative (800-686-0021)",
    "Gas": "Columbia Gas (1-888-460-4332)"
  },
  "Carroll Valley Borough": {
    "Sewer/Water": "Carroll Valley Borough Sewer and Water Authority (717-642-8269)",
    "Trash/Recycling": "Parks Garbage Service (800-486-4490)",
    "Electric": "Adams Electric Co-Operative (800-686-0021), West Penn (800-686-0021)",
    "Gas": "Columbia Gas (1-888-460-4332)"
  },
  "Conewago Township": {
    "Trash/Recycling": "Waste Management (800-593-9529)",
    "Sewer": "Conewago Township Municipal Authority (717-637-0411)",
    "Electric": "Met-Ed (800-545-7741)",
    "Gas": "Columbia Gas (1-888-460-4332)"
  },
  "Cumberland Township": {
    "Sewer": "Cumberland Township Sewer Authority (717-334-1526)",
    "Trash": "Waste Connections (717-709-1700)",
    "Electric": "Adams Electric Co-Operative (800-686-0021), Met-Ed (800-545-7741)",
    "Water": "GMA - Gettysburg Municipal Authority (717-334-6738)",
    "Gas": "Columbia Gas (1-888-460-4332)"
  },
  "East Berlin Borough": {
    "Trash/Recycling": "Waste Connections (717-709-1700)",
    "Water/Sewer": "East Berlin Area Joint Authority (717-259-8370)",
    "Electric": "First Energy (888-544-4877), Met-Ed (800-545-7741)",
    "Gas": "Columbia Gas (1-888-460-4332)"
  },
  "Fairfield Borough": {
    "Water/Sewer": "Fairfield Municipal Authority (717-642-6557)",
    "Trash/Recycling": "Parks Garbage Service (800-486-4490)",
    "Electric": "Met-Ed (800-545-7741)",
    "Gas": "Columbia Gas (1-888-460-4332)"
  },
  "Franklin Township": {
    "Trash/Recycling": "Waste Connections (717-709-1700)",
    "Water": "Franklin Township Municipal Authority (717-334-4901 x100)",
    "Sewer": "PA American Water (800-545-7741)",
    "Electric": "Adams Electric Co-Operative (800-686-0021), Met-Ed (800-545-7741)",
    "Gas": "Private vendor"
  },
  "Freedom Township": {
    "Trash/Recycling": "Parks Garbage Service (800-486-4490)",
    "Water": "Private well",
    "Sewer": "Private septic",
    "Electric": "Adams Electric Co-Operative (800-686-0021), Met-Ed (800-545-7741)",
    "Gas": "Columbia Gas (1-888-460-4332)"
  },
  "Germany Township": {
    "Trash/Recycling": "Private vendor",
    "Water": "Privat well",
    "Sewer": "Private septic",
    "Electric": "Met-Ed (800-545-7741), Adams Electric Co-Operative (800-686-0021)",
    "Gas": "Private vendor"
  },
  "Gettysburg Borough": {
    "Water/Sewer": "Gettysburg Municipal Authority (717-334-6738)",
    "Electric": "Med-Ed (800-545-7741)",
    "Trash/Recycling": "Waste Management (800-593-9529)",
    "Gas": "Columbia Gas (717-677-0421)"
  },
  "Hamilton Township": {
    "Water": "If public - York Water (717-845-3601), otherwise private well",
    "Sewer": "If public - Abbotstown-Paradise Joint Sewer Authority (717-259-9120), New Oxford Municipal Authority (7176-624-9399). Otherwise private septic",
    "Electric": "Met-Ed (800-545-7741), Adams Electric Co-Operative (800-686-0021)",
    "Gas": "Columbia Gas (1-888-460-4332)",
    "Trash/Recycling": "Private vendor"
  },
  "Hamiltonban Township": {
    "Sewer": "Ortanna has sewer, pays PA American Water, the rest is septic (800-545-7741)",
    "Trash/Recycling": "Parks Garbage Service (814-542-4751)",
    "Recycling": "Cumberland County Recycling Center (717-240-6489)",
    "Waste": "Washington Township Station in Waynesboro (717-762-4413)",
    "Electric": "Met-Ed (800-545-7741)",
    "Gas": "Columbia Gas (1-888-460-4332)"
  },
  "Highland Township": {
    "Water": "Private well",
    "Sewer": "Private septic",
    "Electric": "Adams Electric Co-Operative (800-686-0021), Met-Ed (800-545-7741)",
    "Trash/Recycling": "Parks Garbage Service (814-542-4751)",
    "Gas": "Private vendor"
  },
  "Huntington Township": {
    "Water": "Private septic",
    "Sewer": "Private well",
    "Electric": "Met-Ed (800-545-7741), Adams Electric Co-Operative (800-686-0021)",
    "Trash/Recycling": "Waste Management (800-593-9529)",
    "Gas": "Private vendor"
  },
  "Latimore Township": {
    "Water": "Well - unless in the Borough of York Springs - York Springs Municipal Authority (717-528-4032)",
    "Sewer": "Septic - unless in the Borough of York Springs - York Springs Municipal Authority (717-528-4032)",
    "Electric": "Met-Ed (800-545-7741), Adams Electric Co-Operative (800-686-0021)",
    "Trash/Recycling": "Waste Management (800-593-9529)"
  },
  "Liberty Township": {
    "Water": "Private well",
    "Sewer": "Private septic",
    "Gas": "Private vendor",
    "Electric": "West Penn (1-800-686-0021), Adams Electric Co-Operative (800-686-0021)",
    "Trash/Recycling": "Unknown"
  },
  "Littlestown Borough": {
    "Water/Sewer": "If public - Littlestown Norough Authority (717-359-5101), otherwise prive well & private septic",
    "Electric": "Met-Ed (800-545-7741), Adams Electric Co-Operative (800-686-0021)",
    "Trash/Recycling": "Private Vendor",
    "Gas": "Columbia Gas (1-888-460-4332)"
  },
  "McSherrystown Borough": {
    "Sewer/Trash": "McSherrystown Borough (717-637-1838)",
    "Water": "Through Hanover Borough (717-637-3877 x1005)",
    "Electric": "Met-Ed (800-545-7741), Adams Electric Co-Operative (800-686-0021)",
    "Gas": "Columbia Gas (1-888-460-4332)"
  },
  "Menallen Township": {
    "Water/Sewer": "If public - Possum Valley Sewer Authority",
    "Electric": "Met-Ed (800-545-7741), Adams Electric Co-Operative (800-686-0021)",
    "Trash/Recycling": "Waste Connections (717-709-1700)",
    "Gas": "Columbia Gas (1-888-460-4332)"
  },
  "Mt. Joy Township": {
    "Water/Sewer": "Private well & septic, unless in the links or Lake Heritage",
    "Electric": "Met-Ed (800-545-7741)",
    "Trash/Recycling": "Parks Garbage Services (814-542-4751)",
    "Gas": "None available"
  },
  "Mt. Pleasant Township": {
    "Electric": "Adams Electric Co-Operative (800-686-0021), Met-Ed (800-545-7741)",
    "Trash": "Private vendor",
    "Water/Sewer": "Private well & septic, unless in Lake Heritage or Homestead - Bonneauville Borough Municipal Authority (717-334-2662)",
    "Gas": "Not available"

  },
  "Oxford Township": {
    "Water/Sewer": "New Oxford Municipal Authority (717-624-9399)",
    "Trash/Recycling": "Private vendor",
    "Gas": "Columbia Gas (1-888-460-4332)",
    "Electric": "Adams Electric Co-Operative (800-686-0021), Met-Ed (800-545-7741)"
  },
  "Reading Township": {
    "Water": "York Water Company (717-845-3601)",
    "Gas": "Columbia Gas (1-888-460-4332)",
    "Sewer": "Reading Township Municipal Authority (717-479-0843)",
    "Electric": "Met-Ed (800-545-7741)",
    "Trash": "Private vendor"
  },
  "Straban Township": {
    "Water/Sewer": "If public - contact the township as there are several different areas serviced by several districts",
    "Trash": "Waste Connections (717-709-1700)",
    "Electric": "Met-Ed (800-545-7741), few residents have Adams Electric (800-686-0021)",
    "Gas": "Not available"
  },
  "Tyrone Township": {
    "Sewer": "If private - septic, if public - call township (717-528-4012)",
    "Water": "If private - well, if public - call township (717-528-4012)",
    "Trash": "Private vendor like Waste Management (800-593-9529)",
    "Electric": "Met-Ed (800-545-7741), Adams Electric Co-Operative (800-686-0021)",
    "Gas": "Not available"
  },
  "York Springs Borough": {
    "Water/Sewer": "York Springs Municipal Authority",
    "Trash/Recycling": "Parks Garbage Service (814-542-4751)",
    "Electric": "Met-Ed (800-545-7741)",
    "Gas": "Not available"
  }
  },


  //Berks County
  Berks: {
    "Reading": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Reading Area Water Authority",
      Water: "Reading Area Water Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "West Reading": {
      Gas: "UGI Utilities",
      Trash: "Hollenbaugh's Trash & Recycling, LLC",
      Electric: "Met-Ed",
      Sewer: "Joint Municipal Authority of Wyomissing Valley",
      Water: "Western Berks Water Authority",
      Recycling: "Hollenbaugh's Trash & Recycling, LLC",
      WiFi: "Comcast/Xfinity"
    },
    "Wyomissing": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Wyomissing Borough Authority",
      Water: "Wyomissing Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Kutztown": {
      Gas: "UGI Utilities",
      Trash: "Kutztown Borough Public Works",
      Electric: "Kutztown Electric Department",
      Sewer: "Kutztown Wastewater Department",
      Water: "Kutztown Water Department",
      Recycling: "Kutztown Borough Public Works",
      WiFi: "Home Net (Hometown Utilicom)"
    },
    "Hamburg": {
      Gas: "UGI Utilities",
      Trash: "Waste Management",
      Electric: "Met-Ed",
      Sewer: "Hamburg Borough Authority",
      Water: "Hamburg Borough Authority",
      Recycling: "Waste Management",
      WiFi: "Service Electric"
    },
    "Shillington": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Shillington Borough Authority",
      Water: "Shillington Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Mohnton": {
      Gas: "UGI Utilities",
      Trash: "Waste Management",
      Electric: "Met-Ed",
      Sewer: "Mohnton Borough Authority",
      Water: "Mohnton Borough Authority",
      Recycling: "Waste Management",
      WiFi: "Service Electric"
    },
    "Fleetwood": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Fleetwood Borough Authority",
      Water: "Fleetwood Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Birdsboro": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Birdsboro Municipal Authority",
      Water: "Birdsboro Municipal Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Boyertown": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Boyertown Borough Authority",
      Water: "Boyertown Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Hamburg": {
      Gas: "UGI Utilities",
      Trash: "Waste Management",
      Electric: "Met-Ed",
      Sewer: "Hamburg Borough Authority",
      Water: "Hamburg Borough Authority",
      Recycling: "Waste Management",
      WiFi: "Service Electric"
    },
    "Laureldale": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Laureldale Borough Authority",
      Water: "Laureldale Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Leesport": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Leesport Borough Authority",
      Water: "Leesport Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Lenhartsville": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Lenhartsville Borough Authority",
      Water: "Lenhartsville Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Longswamp Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Longswamp Township Authority",
      Water: "Longswamp Township Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Lower Alsace Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Lower Alsace Township Authority",
      Water: "Lower Alsace Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Lower Heidelberg Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Lower Heidelberg Township Authority",
      Water: "Lower Heidelberg Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Lyons": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Lyons Borough Authority",
      Water: "Lyons Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Maidencreek Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Maidencreek Township Authority",
      Water: "Maidencreek Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Marion Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Marion Township Authority",
      Water: "Marion Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Maxatawny Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Maxatawny Township Authority",
      Water: "Maxatawny Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Mohnton": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Mohnton Borough Authority",
      Water: "Mohnton Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Mt. Penn": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Mt. Penn Borough Authority",
      Water: "Mt. Penn Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Muhlenberg Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Muhlenberg Township Authority",
      Water: "Muhlenberg Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "New Morgan": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "New Morgan Borough Authority",
      Water: "New Morgan Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "North Heidelberg Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "North Heidelberg Township Authority",
      Water: "North Heidelberg Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Oley Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Oley Township Authority",
      Water: "Oley Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Ontelaunee Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Ontelaunee Township Authority",
      Water: "Ontelaunee Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Penn Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Penn Township Authority",
      Water: "Penn Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Perry Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Perry Township Authority",
      Water: "Perry Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Pike Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Pike Township Authority",
      Water: "Pike Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Richmond Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Richmond Township Authority",
      Water: "Richmond Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Robeson Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Robeson Township Authority",
      Water: "Robeson Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Robesonia": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "North Heidelberg Township Sewage Authority",
      Water: "Womelsdorf-Robesonia Joint Water Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Rockland Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Rockland Township Authority",
      Water: "Rockland Township Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Ruscombmanor Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Ruscombmanor Township Authority",
      Water: "Ruscombmanor Township Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Shillington": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Shillington Borough Authority",
      Water: "Shillington Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Shoemakersville": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Shoemakersville Borough Authority",
      Water: "Shoemakersville Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Sinking Spring": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Sinking Spring Borough Authority",
      Water: "Sinking Spring Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "South Heidelberg Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "South Heidelberg Township Authority",
      Water: "South Heidelberg Township Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Spring Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Spring Township Authority",
      Water: "Spring Township Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "St. Lawrence": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "St. Lawrence Borough Authority",
      Water: "St. Lawrence Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Tilden Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Tilden Township Authority",
      Water: "Tilden Township Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Topton": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Topton Borough Authority",
      Water: "Topton Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Tulpehocken Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Tulpehocken Township Authority",
      Water: "Tulpehocken Township Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Union Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Union Township Authority",
      Water: "Union Township Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Upper Bern Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Upper Bern Township Authority",
      Water: "Upper Bern Township Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Upper Tulpehocken Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Upper Tulpehocken Township Authority",
      Water: "Upper Tulpehocken Township Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Washington Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Washington Township Authority",
      Water: "Washington Township Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Wernersville": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Wernersville Municipal Authority",
      Water: "Wernersville Municipal Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "West Reading": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "West Reading Borough Authority",
      Water: "West Reading Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Comcast/Xfinity"
    },
    "Windsor Township": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Windsor Township Authority",
      Water: "Windsor Township Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Womelsdorf": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Womelsdorf Municipal Authority",
      Water: "Womelsdorf Municipal Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    },
    "Wyomissing": {
      Gas: "UGI Utilities",
      Trash: "Republic Services",
      Electric: "Met-Ed",
      Sewer: "Wyomissing Borough Authority",
      Water: "Wyomissing Borough Authority",
      Recycling: "Republic Services",
      WiFi: "Service Electric"
    }
  },


  //Cumberland County
  Cumberland: {
    "Camp Hill Borough": {
      Electric: "Private vendor",
      Sewer: "CampHill Sewer Department managed by Camp Hill Borough (717-737-3456 x1022)",
      Water: "Managed by borough (717-737-3456 x1002)",
      Trash: "Penn Waste managed by borough (717-737-3456 x1002)",
      Gas: "Private vendor"
    },
    "Carlisle Borough": {
      Electric: "Private vendor",
      Sewer: "Private septic",
      "Water/Sewer": "Managed by borough (717-249-4422)",
      Trash: "Purchase trash collection stickers through borough (717-249-4422)",
      Gas: "Private vendor"
    },
    "Cooke Township": {
      Electric: "Met-Ed (suggested by township to have generator as well)",
      Sewer: "Private septic",
      Water: "Private well",
      Trash: "Park's Garbage Services managed thorugh township",
      Gas: "Not available"
    },
    "Dickinson Township": {
      Electric: "PPL Electric Utilities (800-342-5775) or Met Ed (800-545-7741)",
      "Water/Sewer": "Dickinson Township Municipal Authority (717-486-7424)",
      Trash: "Apple Valley Waste / Parks Garage (877-267-1280)",
      Gas: "Private vendor"
    },
    "East Pennsboro Township": {
      Electric: "Private vendor",
      Sewer: "Managed by township (717-732-0711)",
      Water: "PA American Water (800-565-7292)",
      Trash: "Waste Management managed through township (717-732-0711 x2)",
      Gas: "Not available"
    },
    "Hampden Township": {
      Electric: "PPL Electric Utilities (800-342-5775)",
      "Sewer/Trash": "Manged by township (717-761-0119)",
      Water: "Depends where you live; PA American Water (717-744-7836) or Veolia Water (717-564-3664)",
      Gas: "UGI (800-276-2722)"
    },
    "Hopewell Township": {
      Electric: "Depending on where you live, Penelec (800-545-7741) or Adams County Electric (800-726-2324)",
      Sewer: "Newburg-Hopewell Joint Sewer Authority (717-414-3313)",
      Water: "Private well",
      Trash: "5 bags of trash to landfill for free each week (need landfill ID card) and Parks Garbage serviced through Southampton Township (717-423-6582)",
      Gas: "Not available"
    },
    "Lemoyne Borough": {
      Electric: "PPL Electric Utilities (800-342-5775)",
      Sewer: "Lemoyne Municipal Authority (717-737-6843)",
      Water: "PA American Water (800-565-7292)",
      Trash: "Private vendor",
      Gas: "UGI (800-276-2722)"
    },
    "Lower Allen Township": {
      Electric: "PPL Electric Utilities (800-342-5775)",
      "Sewer/Trash": "Lower Allen Township (717-975-7575)",
      Water: "Mainly PA American Water (800-565-7292), some Veolia (717-564-3664)",
      Gas: "UGI (800-276-2722)"
    },
    "Lower Frankford Township": {
      Electric: "Adams Electric Cooperative",
      Sewer: "Private septic",
      Water: "Private well",
      Trash: "Managed by Lower Frankford Township through Southampton Township Trash Office (717-243-0855)",
      Gas: "Not available"
    },
    "Lower Mifflin Township": {
      Electric: "PPL Electric Utilities (800-342-5775)",
      Sewer: "Private septic",
      Water: "Private well",
      Trash: "Managed by Lower Mifflin Township through Southampton Township Trash Office (717-776-6121)",
      Gas: "Not available"
    },
    "Mechanicsburg Borough": {
      Electric: "PPL Electric Utilities (800-342-5775)",
      "Sewer/Trash/Stormwater": "Borough of Mechanicsburg (717-691-3310)",
      Water: "Veolia (717-564-3664)",
      Gas: "UGI (800-276-2722)"
    },
    "Middlesex Township": {
      Electric: "PPL Electric Utilities (800-342-5775)",
      "Water/Sewer": "Middlesex Township Municipal Authority (717-243-0674)",
      Trash: "Penn Waste managed by Middlesex Township",
      Gas: "Some UGI (800-276-2722) others not available"
    },
    "Monroe Township": {
      Electric: "PPL Electric Utilities (800-342-5775) or Met Ed (800-545-7741)",
      Sewer: "Monroe Township (717-258-6642)",
      Water: "PA American Water (800-565-7292), or Veolia (717-564-3664) depending on location",
      Trash: "Penn Waste (717-767-4456)",
      Gas: "Some UGI (800-276-2722) others not available"
    },
    "Mt. Holly Springs Borough": {
      Electric: "Met Ed (800-545-7741)",
      "Water/Sewer/Trash": "Mt Holly Springs Borough Authority (717-486-7613)",
      Gas: "UGI (800-276-2722)"
    },
    "New Cumberland Borough": {
      Electric: "PPL Electric Utilities (800-342-5775)",
      "Water/Sewer": "PA Amerian Water (717-258-6642)",
      Trash: "Penn Wast managed by New Cumberland Borough (717-744-0404)",
      Gas: "UGI (800-276-2722)"
    },
    "Newburg Borough": {
      Electric: "Penelec (800-545-7741)",
      Sewer: "Newburg-Hopewell Joint Sewer Authority (717-552-4280)",
      Water: "Private well",
      Trash: "Residents either take trash to cumberland county landfill for free or register with Newburg Borough for trash through the Southampton Township trash (717-423-0050)",
      Gas: "Not available"
    },
    "Newville Borough": {
      Electric: "PPL Electric Utilities (800-342-5775)",
      "Water/Sewer": "Newville Water & Sewer Authority (717-776-7633)",
      Trash: "Managed by borough and is through South Hampton Township Trash office (717-776-7633)",
      Gas: "Not available"
    },
    "North Middleton Township": {
      Electric: "PPL Electric Utilities (800-342-5775)",
      "Water/Sewer": "North Middleton Authority (717-243-8550)",
      Trash: "Managed by North Middleton Township, through Republic Service (717-243-8550)",
      Gas: "UGI (800-276-2722)"
    },
    "North Newton Township": {
      Electric: "PPL Electric Utilities (800-342-5775) or Penelec (800-545-7741)",
      Sewer: "Private septic or private vendor",
      Water: "Mostly well, few have public water through Borough of Newville (717-776-7665)",
      Trash: "Managed by North Newton Township through Southampton Township Trash office (717-776-7665)",
      Gas: "Not available"
    },
    "Penn Township": {
      Electric: "PPL Electric Utilities (800-342-5775)",
      Water: "PA American Water (717-258-6642)",
      Trash: "Managed by Penn Township through Southampton Township Trash Office (717-486-3104)",
      Gas: "UGI (800-276-2722)"
    },
    "Shippensburg Borough": {
      Electric: "PPL Electric Utilities (800-342-5775) or West Penn Power",
      Sewer: "Shippensburg Borough Sewer Department (717-532-6949)",
      Water: "Shippensburg Borough Water Authority (717-532-2147)",
      Trash: "Shippensburg Borough (717-532-2147)",
      Gas: "UGI (800-276-2722)"
    },
    "Shippensburg Township": {
      Electric: "PPL Electric Utilities (800-342-5775) or West Penn Power",
      Sewer: "Cumberland-Franklin joint Municipal Authority (717-532-6949)",
      Water: "Shippensburg Borough Water Authority (717532-2147)",
      Trash: "Managed by Southhampton Township, through Parks Garage (717-532-7685)",
      Gas: "Not available"
    },
    "Shiremanstown Borough": {
      Sewer: "Lower Allen Township (717-975-7575)",
      Water: "PA American Water (717-258-6642)",
      Trash: "Waste Management (800-634-4595)",
      Gas: "Shipley (800-839-1849)"
    },
    "Silver Spring Township": {
      Electric: "PPL Electric Utilities (800-342-5775)",
      Sewer: "Silver Spring Township Authority (717-591-1370)",
      Water: "PA American Water (800-565-7292), or Veolia (717-564-3664) depending on location",
      Trash: "PennWaste (717-766-0178)",
      Gas: "UGI (800-276-2722)"
    },
    "South Middleton Township": {
      Electric: "Private vendor",
      "Water/Sewer": "South Middleton Township Municipal Authority (717-258-6476)",
      Trash: "Waste Management (800-634-4595)",
      Gas: "UGI (800-276-2722)"
    },
    "South Newton Township": {
      Electric: "PPL Electric Utilities (800-342-5775)",
      Sewer: "Private septic",
      Water: "Private well",
      Trash: "Managed by Southhamptotn Township through Apple Valley Waste (717-532-9646)",
      Gas: "Not available"
    },
    "Southampton Township": {
      Electric: "Adams Electric (800-726-2324) or Penelec",
      Sewer: "Cumberland Franklin Joint Municipal Authority (717-532-6949)",
      Water: "Southern Cumberland Water Association (717-258-5555)",
      Trash: "Southampton Trash (717-532-9646)",
      Gas: "UGI (800-276-2722)"
    },
    "Upper Allen Township": {
      Electric: "PPL Electric Utilities (800-342-5775)",
      Sewer: "Upper Allen Township (717-766-0756)",
      Water: "Veolia (888-299-8972)",
      Trash: "Republic Servies services (800-210-9675)",
      Gas: "UGI (800-276-2722)"
    },
    "Upper Frankford Township": {
      Electric: "Adams Electric (800-726-2324)",
      Sewer: "Private septic",
      Water: "Private well",
      Trash: "Managed through Southampton Township through Parks Apple Valley",
      Gas: "Not available"
    },
    "Upper Mifflin Township": {
      Electric: "Adams Electric (800-726-2324)",
      Sewer: "Private septic",
      Water: "Private well",
      Trash: "Private vendor",
      Gas: "Not available"
    },
    "West Pennsboro Township": {
      Electric: "Private vendor",
      "Water/Sewer": "West Pennsboro Township Municipal Authority (717-243-1923)",
      Trash: "Southhampton Township Trash Office (717-243-8220)",
      Gas: "UGI (800-276-2722)"
    },
    "Wormleysburg Borough": {
      Electric: "Private vendor",
      "Sewer/Trash": "Wormleysburg Borough (717-763-4483)",
      Water: "PA American Water (717-258-6642)",
      Gas: "Private vendor"
    }
  },


  //Dauphin County
  Dauphin: {
    "Berrysburg Borough": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "No Gas, private tanks",
      "Sewer": "Berrysburg Municipal Authority (717-497-7454)",
      "Water": "Private well",
      "Trash/Recycling": "Private Vendors"
    },
    "Conewago Township": {
      "Electric": "Met-Ed (800-545-7741)",
      "Gas": "If public - UGI (800-276-2722), otherwise private tanks",
      "Water": "If public - Pennsylvania American Water (1-800-565-7292), otherwise private wells",
      "Sewer": "If public - Derry Township Municipal Authority (717-566-3237), otherwise private septic system",
      "Trash/Recycling": "Residents arrange individual pickup, recycling center is operated by Dauphin County Waste Management (717-982-6772)"
    },
    "Dauphin Borough": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water": "Veolia (888-844-0352)",
      "Sewer": "Dauphin Borough Sewer Authority (717-421-1228)",
      "Trash/Recycling": "Serviced by Waste Management, Billed through Dauphin Borough (717-921-2633)"
    },
    "Derry Township": {
      "Electric": "PPL Electric Utilites (800-342-5775) or Met Ed (2% of residents) (800-545-7741)",
      "Gas": "UGI (800-276-2722)",
      "Water": "PA American Water Company (1-866-269-2837)",
      "Sewer": "Derry Township Municipal Authority",
      "Trash/Recycling": "Waste Management (800-866-4460)"
    },
    "East Hanover Township": {
      "Electric": "PPL Electric Utilites (800-342-5775) or First Energy (888-544-4877)",
      "Gas": "UGI Utilities (800-276-2722)",
      "Sewer": "East Hanover Township Municipal Authority (717-469-0833)",
      "Water": "Private Well",
      "Trash/Recycling": "Penn Waste Inc (1-866-575-8720)"
    },
    "Elizabethtown Borough": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Sewer/Trash (Outside of Borough)": "Elzabethtown Regional Sewer Authority (717-367-3721) (trash is still billed through borough)",
      "Sewer/Trash (Inside of Borough)": "Elizabethtown Borough bill sewer and trash together (717-367-1700)",
      "Water": "Eliazbethtown Area Water Authority (717-367-7448)"
    },
    "Elizabethville Borough": {
      "Electric": "Just Energy (866-587-8674)",
      "Gas": "NRG (855-388-5276)",
      "Water/Sewer": "Elizabethville Area Authority (717-362-3582)",
      "Trash/Recycling": "Casella (717-913-4076)"
    },
    "Gratz Borough": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "NRG (855-388-5276)",
      "Water/Sewer": "Gratz Borough (717-365-4115)",
      "Trash/Recycling": "Casella (717-913-4076)"
    },
    "Halifax Borough": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water/Sewer": "Halifax Water and Sewer Authority (717-896-6705)",
      "Trash/Recycling": "Private Vendor"
    },
    "Halifax Township": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "Private Vendor",
      "Water/Sewer": "Halifax Water and Sewer Authority (717-856-6705)",
      "Trash/Recycling": "Private Vendor"
    },
    "Harrisburg City": {
      "Electric": "PPL Electric Utilites (717-257-5922)",
      "Gas": "UGI Utilities (800-276-2722)",
      "Water/Sewer": "Harrisburg City Serviced by Capital Region Water Payment Portal (888-510-06060)",
      "Trash/Recycling": "City of Harrisburg Department of Public Works (717-412-4320)"
    },
    "Highspire Borough": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Sewer": "Highspire Borough (717-939-3303)",
      "Water": "Veolia (888-844-0352)",
      "Trash": "Billed in the real estate taxes by the borough (717-939-3303)"
    },
    "Hummelstown Borough": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water/Sewer": "Hummelstown Borough serviced by Veolia (717-566-2555), Hummelstown Borough Sewer (717-566-2555)",
      "Trash/Recycling": "Hummelstown Borough serviced by Republic Services (717-566-2555)"
    },
    "Jackson Township": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "No gas, private if available",
      "Water": "Private Wells",
      "Sewer": "Private septic",
      "Trash/Recycling": "Private Vendor"
    },
    "Jefferson Township": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water/Sewer": "Jefferson Township Sewer Authority (570-689-7028)",
      "Trash/Recycling": "Waste Management (800-677-4884), PennWaste (866-575-8720), Republic Services (800-210-9675)"
    },
    "Londonderry Township": {
      "Electric": "Met Ed (First Energy) (1-888-478-2300)",
      "Gas": "UGI (800-276-2722)",
      "Water/Sewer": "Contact Londonderry Township office (717-944-1803)",
      "Trash/Recycling": "X/S Waste Transport (717-367-7375)"
    },
    "Lower Paxton Township": {
      "Electric": "PPL Electric Utilites (1-800-342-5775)",
      "Gas": "UGI Utilities (1-800-276-2722)",
      "Water": "Veolia (888-299-8972)",
      "Sewer": "Lower Paxton Township Sewer Authority (717-657-5617)",
      "Trash/Recycling": "Penn Waste Inc (717-767-4456)"
    },
    "Lower Swatara Township": {
      "Electric": "PPL Electric Utilites (1-800-342-5775)",
      "Gas": "UGI Utilities (717-234-5951)",
      "Water": "Veolia (888-299-8972)",
      "Sewer": "Lower Swatara Township (717-939-9377)",
      "Trash/Recycling": "Republic Services of York (1-800-210-9675)"
    },
    "Lykens Borough": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water/Sewer/Trash": "Lykens Water Authority (717-453-7597)"
    },
    "Lykens Township": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water": "Private Wells",
      "Sewer": "Private Septic",
      "Trash/Recycling": "Private Vendor"
    },
    "Middle Paxton Township": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI Utilities (1-800-276-2722)",
      "Water": "If public - Veolia (888-844-0352), otherwise private wells",
      "Sewer": "If public - Dauphin Borough Sewer Authority, otherwise private septic system",
      "Trash/Recycling": "Valley Waste Solutions, Inc (717-647-9391)"
    },
    "Middletown Borough": {
      "Electric": "Middletown Borough (717-902-0706)",
      "Gas": "UGI (1-800-276-2722)",
      "Water/Sewer": "Veolia (888-844-0352)",
      "Trash/Recycling": "Serviced by Penn Waste Inc. Billed with electric bill through Middletown Borough (See above for contact)"
    },
    "Millersburg Borough": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water/Sewer": "Millersburg Area Authority managed by borough (717-692-4711)",
      "Trash/Recycling": "Managed by Millersburg Borough (717-692-2389)"
    },
    "Mifflin Township": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water/Sewer": "Mifflin County Municipal Authority managed by township (717-248-0165)",
      "Trash/Recycling": "Park's Garbage Service (814-542-4751)"
    },
    "Paxtang Borough": {
      "Electric": "PPL Electric Utilites (800-342-5775) or hire a private vendor",
      "Gas": "UGI (800-276-2722) or hire a private vendor",
      "Water/Sewer": "Veolia (717-564-3662)",
      "Trash/Recycling": "Paxtang Trash (717-695-9716)"
    },
    "Penbrook Borough": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water": "Capital Region Water (888-510-0606) or Veolia Water (717-564-3662), depending where you live",
      "Sewer": "Included in your property Taxes",
      "Trash/Recycling": "City of Harrisburg Department of Public Works (717-695-9716)"
    },
    "Pillow Borough": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "NRG (855-388-5276) or UGI (800-276-2722)",
      "Water/Sewer": "Pillow Water Authority (570-758-2420)",
      "Trash/Recycling": "Penn Waste (717-767-4456)"
    },
    "Reed Township": {
      "Electric": "PPL Electric Utilites (800-342-5775) or NRG (855-388-5276)",
      "Gas": "NRG (855-388-5276)",
      "Water/Sewer": "Call Borough (717-896-8904)",
      "Trash/Recycling": "Call Borough (717-896-8904)"
    },
    "Royalton Borough": {
      "Electric": "Royalton Borough (717-944-4831)",
      "Gas": "UGI (800-276-2722)",
      "Water/Sewer": "Royalton Borough (717-944-4831)",
      "Trash/Recycling": "Republic Services (717-845-1557)"
    },
    "Rush Township": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water/Sewer": "Rush Township Sewer Authority (570-668-2938)",
      "Trash/Recycling": "Tamaqua Transfer & Recycling (570-668-4515)"
    },
    "South Hanover Township": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water": "Managed by South Hanover Township (PA American Water & Veolia Water) (717-566-0224)",
      "Sewer": "Township of South Hanover (717-566-0224)",
      "Trash/Recycling": "Penn Waste managed by South Hanover Township (717-466-0224)"
    },
    "Steelton Borough": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water/Sewer": "Pennsylvania American Water (800-565-7292), Steelton Borough (717-939-5012)",
      "Trash/Recycling": "Public Works Department (City of Harrisburg) (717-695-9716)"
    },
    "Susquehanna Township": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water": "Capital Region Water (888-510-0606), Veolia (888-299-8972)",
      "Sewer": "Susqehanna Township Municipal Authority (717-545-4751)",
      "Trash/Recycling": "Susquehanna Township Public Works (717-545-4751)"
    },
    "Swatara Township": {
      "Electric": "PPL Electric Utilites (800) 342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water": "Steelton Water Service (717-939-0425) or Veolia (888-299-8972)",
      "Sewer": "Swatara Township Sewer Authority (717-564-1650)",
      "Trash/Recycling": "Penn Waste Inc (717-767-4456)"
    },
    "Upper Paxton Township": {
      "Electric": "PPL Electric Utilites (800-342-5775) or hire a private vendor",
      "Gas": "No gas, possibly private tanks",
      "Water/Sewer": "Millersburg Area Authority (717-692-4711)",
      "Recycling": "Dauphin County Recycling Center (717-982-6772)",
      "Trash": "Can hire a private vendor"
    },
    "Washington Township": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water/Sewer": "Elizabethville Area Authority managed by township (717-652-4841)",
      "Trash/Recycling": "Call Township (717-362-3191)"
    },
    "West Hanover Township": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water": "PA American Water Company managed by township (717-652-4841)",
      "Sewer": "Managed by West Hanover Township Sewer Authority (717-461-2727)",
      "Trash/Recycling": "Republic Services managed by West Hanover Twp (717-652-4841)"
    },
    "Wayne Township": {
      "Electric": "Call Township (717-362-3505)",
      "Gas": "Call Township (717-362-3505)",
      "Water/Sewer": "Wayen Township Municipal Authority (717-899-6701)",
      "Trash/Recycling": "Call Township (717-362-3505)"
    },
    "Wiconisco Township": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "NRG (855-388-5276)",
      "Water": "Lykens Borough",
      "Sewer": "Williamstown Borough Authority (717-647-4848)",
      "Trash/Recycling": "Valley Waste Solutions, Inc. (717-647-9391)"
    },
    "Williams Township": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water/Sewer": "Managed by Williamstown Borough Authority (717-647-4848)",
      "Trash/Recycling": "Casella (908-562-6133)"
    },
    "Williamstown Borough": {
      "Electric": "PPL Electric Utilites (800-342-5775)",
      "Gas": "UGI (800-276-2722)",
      "Water/Sewer": "Managed by Williamstown Borough Authority (717-647-4848)",
      "Trash/Recycling": "Casella (908-562-6133)"
    }
  },


  //Juniata County
  Juniata: {
    "Beale Township": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Delaware Township": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Fayette Township": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Fermanagh Township": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Greenwood Township": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Lack Township": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Mifflin Borough": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Mifflintown Borough": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Milford Township": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Monroe Township": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Port Royal Borough": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Spruce Hill Township": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Susquehanna Township": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Thompsontown Borough": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Turbett Township": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Tuscarora Township": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    },
    "Walker Township": {
      Gas: "UGI Utilities",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Twin Boroughs Sanitary Authority",
      Water: "Port Royal Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Nittany Media Inc."
    }
  },


  //Lancaster County
  Lancaster: {
    "Adamstown Borough": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Ephrata Borough Authority",
      Water: "Ephrata Borough Authority",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Akron Borough": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Ephrata Borough Authority",
      Water: "Ephrata Borough Authority",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Bart Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Brecknock Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Caernarvon Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Christiana Borough": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Christiana Borough Authority",
      Water: "Christiana Borough Authority",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Clay Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Colerain Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Columbia Borough": {
      Gas: "UGI Utilities",
      Trash: "Waste Management",
      Electric: "PPL Electric Utilities",
      Sewer: "Columbia Borough Authority",
      Water: "Columbia Borough Authority",
      Recycling: "Waste Management",
      WiFi: "Xfinity"
    },
    "Conestoga Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Conoy Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Denver Borough": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Ephrata Borough Authority",
      Water: "Ephrata Borough Authority",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Drumore Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Earl Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "East Cocalico Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "East Donegal Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "East Drumore Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "East Earl Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "East Hempfield Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Lancaster Area Sewer Authority",
      Water: "Lancaster Area Sewer Authority",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "East Lampeter Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Lancaster Area Sewer Authority",
      Water: "Lancaster Area Sewer Authority",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Eden Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Elizabeth Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Elizabethtown Borough": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Elizabethtown Area Water Authority",
      Water: "Elizabethtown Area Water Authority",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Ephrata Borough": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "Ephrata Borough Electric Division",
      Sewer: "Ephrata Borough Authority",
      Water: "Ephrata Borough Authority",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Ephrata Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Ephrata Borough Authority",
      Water: "Ephrata Borough Authority",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Fulton Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Lancaster City": {
      Gas: "UGI Utilities",
      Trash: "City of Lancaster Public Works",
      Electric: "PPL Electric Utilities",
      Sewer: "City of Lancaster Bureau of Sewer",
      Water: "City of Lancaster Bureau of Water",
      Recycling: "City of Lancaster Public Works",
      WiFi: "Xfinity"
    },
    "Lancaster Township": {
      Gas: "UGI Utilities",
      Trash: "Lancaster Township Public Works",
      Electric: "PPL Electric Utilities",
      Sewer: "Lancaster Township Sewer Authority",
      Water: "Lancaster Township Water Authority",
      Recycling: "Lancaster Township Public Works",
      WiFi: "Xfinity"
    },
    "Leacock Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Lititz Borough": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Lititz Borough Authority",
      Water: "Lititz Borough Authority",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Little Britain Township": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Manheim Borough": {
      Gas: "UGI Utilities",
      Trash: "Good's Disposal",
      Electric: "PPL Electric Utilities",
      Sewer: "Manheim Borough Authority",
      Water: "Manheim Borough Authority",
      Recycling: "Good's Disposal",
      WiFi: "Xfinity"
    },
    "Manheim Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Lancaster Area Sewer Authority",
      Water: "Lancaster Area Sewer Authority",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Manor Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Manor Township Joint Municipal Authority",
      Water: "Manor Township Joint Municipal Authority",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Marietta Borough": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Columbia Water Company",
      Water: "Columbia Water Company",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Martic Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Millersville Borough": {
      Gas: "UGI Utilities",
      Trash: "Millersville Borough",
      Electric: "PPL Electric Utilities",
      Sewer: "Millersville Borough",
      Water: "Millersville Borough",
      Recycling: "Millersville Borough",
      WiFi: "Xfinity"
    },
    "Mount Joy Borough": {
      Gas: "UGI Utilities",
      Trash: "Mount Joy Borough",
      Electric: "PPL Electric Utilities",
      Sewer: "Mount Joy Borough Authority",
      Water: "Mount Joy Borough Authority",
      Recycling: "Mount Joy Borough",
      WiFi: "Xfinity"
    },
    "Mount Joy Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Mount Joy Borough Authority",
      Water: "Mount Joy Borough Authority",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Mountville Borough": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Mountville Borough Authority",
      Water: "Mountville Borough Authority",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "New Holland Borough": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "New Holland Borough",
      Water: "New Holland Borough",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Paradise Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Penn Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Northwestern Lancaster County Authority",
      Water: "Northwestern Lancaster County Authority",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Pequea Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Providence Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Quarryville Borough": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Quarryville Borough",
      Water: "Quarryville Borough",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Rapho Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Mount Joy Borough Authority",
      Water: "Mount Joy Borough Authority",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Sadsbury Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Salisbury Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Lancaster Area Sewer Authority",
      Water: "Lancaster Area Sewer Authority",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Strasburg Borough": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Strasburg Borough",
      Water: "Strasburg Borough",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Strasburg Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Strasburg Borough",
      Water: "Strasburg Borough",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Terre Hill Borough": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Terre Hill Borough",
      Water: "Terre Hill Borough",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Upper Leacock Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Lancaster Area Sewer Authority",
      Water: "Lancaster Area Sewer Authority",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "Warwick Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Lancaster Area Sewer Authority",
      Water: "Lancaster Area Sewer Authority",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "West Cocalico Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Not Available",
      Water: "Not Available",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "West Donegal Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Mount Joy Borough Authority",
      Water: "Mount Joy Borough Authority",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "West Earl Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Lancaster Area Sewer Authority",
      Water: "Lancaster Area Sewer Authority",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "West Hempfield Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Lancaster Area Sewer Authority",
      Water: "Lancaster Area Sewer Authority",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    },
    "West Lampeter Township": {
      Gas: "UGI Utilities",
      Trash: "Residents choose from registered haulers",
      Electric: "PPL Electric Utilities",
      Sewer: "Lancaster Area Sewer Authority",
      Water: "Lancaster Area Sewer Authority",
      Recycling: "Residents choose from registered haulers",
      WiFi: "Xfinity"
    }
  },


  //Lebanon County
  Lebanon: {
    "Annville Township": {
      Gas: "UGI Utilities",
      Trash: "Casella Waste Systems",
      Electric: "Met-Ed",
      Sewer: "Annville Township Sewer Authority",
      Water: "Annville Township Water Authority",
      Recycling: "Casella Waste Systems",
      WiFi: "Comcast/Xfinity"
      },
      "Bethel Township": {
          Gas: "UGI Utilities",
          Trash: "Opdenaker Sanitation",
          Electric: "PPL Electric",
          Sewer: "Bethel Township Sewer Authority",
          Water: "Chester Water Authority / Veolia Water",
          Recycling: "Opdenaker Sanitation",
          WiFi: "Verizon Fios"
      },
      "Cleona Borough": {
          Gas: "UGI Utilities",
          Trash: "Weidle Sanitation Service",
          Electric: "Met-Ed",
          Sewer: "Cleona Borough Sewer Authority",
          Water: "Cleona Borough Water Authority",
          Recycling: "Weidle Sanitation Service",
          WiFi: "Comcast/Xfinity"
      },
      "Cornwall Borough": {
          Gas: "UGI Utilities",
          Trash: "Weidle Sanitation Service",
          Electric: "Met-Ed",
          Sewer: "Cornwall Borough Sewer Authority",
          Water: "Cornwall Borough Water Authority",
          Recycling: "Weidle Sanitation Service",
          WiFi: "Comcast/Xfinity"
      },
      "East Hanover Township": {
          Gas: "UGI Utilities",
          Trash: "Penn Waste",
          Electric: "PPL Electric",
          Sewer: "East Hanover Township Municipal Authority",
          Water: "East Hanover Township Municipal Authority",
          Recycling: "Penn Waste",
          WiFi: "Verizon Fios"
      },
      "Heidelberg Township": {
          Gas: "UGI Utilities",
          Trash: "Waste Management",
          Electric: "Met-Ed",
          Sewer: "Heidelberg Township Sewer Authority",
          Water: "Heidelberg Township Water Authority",
          Recycling: "Waste Management",
          WiFi: "Comcast/Xfinity"
      },
      "Jackson Township": {
          Gas: "UGI Utilities",
          Trash: "Waste Management",
          Electric: "Met-Ed",
          Sewer: "Jackson Township Sewer Authority",
          Water: "Jackson Township Water Authority",
          Recycling: "Private choice (e.g., Waste Management)",
          WiFi: "Verizon Fios"
      },
      "Jonestown Borough": {
          Gas: "UGI Utilities",
          Trash: "Weidle Sanitation Service",
          Electric: "Met-Ed",
          Sewer: "Jonestown Borough Sewer Authority",
          Water: "Jonestown Borough Water Authority",
          Recycling: "Weidle Sanitation Service",
          WiFi: "Comcast/Xfinity"
      },
      "Lebanon City": {
          Gas: "UGI Utilities",
          Trash: "Republic Services",
          Electric: "Lebanon Utilities",
          Sewer: "Lebanon City Sewer Authority",
          Water: "Lebanon City Water Authority",
          Recycling: "Republic Services",
          WiFi: "Comcast/Xfinity"
      },
      "Millcreek Township": {
          Gas: "UGI Utilities",
          Trash: "Waste Management",
          Electric: "Met-Ed",
          Sewer: "Millcreek Township Sewer Authority",
          Water: "Millcreek Township Water Authority",
          Recycling: "Waste Management",
          WiFi: "Verizon Fios"
      },
      "Mount Gretna Borough": {
          Gas: "UGI Utilities",
          Trash: "Weidle Sanitation Service",
          Electric: "Met-Ed",
          Sewer: "Mount Gretna Borough Sewer Authority",
          Water: "Mount Gretna Borough Water Authority",
          Recycling: "Weidle Sanitation Service",
          WiFi: "Comcast/Xfinity"
      },
      "Myerstown Borough": {
          Gas: "UGI Utilities",
          Trash: "Waste Management",
          Electric: "Met-Ed",
          Sewer: "Myerstown Borough Sewer Authority",
          Water: "Myerstown Borough Water Authority",
          Recycling: "Waste Management",
          WiFi: "Verizon Fios"
      },
      "North Annville Township": {
          Gas: "UGI Utilities",
          Trash: "Republic Services",
          Electric: "Met-Ed",
          Sewer: "North Annville Township Sewer Authority",
          Water: "North Annville Township Water Authority",
          Recycling: "Republic Services",
          WiFi: "Comcast/Xfinity"
      },
      "North Cornwall Township": {
          Gas: "UGI Utilities",
          Trash: "Weidle Sanitation Service",
          Electric: "Met-Ed",
          Sewer: "North Cornwall Township Sewer Authority",
          Water: "North Cornwall Township Water Authority",
          Recycling: "Weidle Sanitation Service",
          WiFi: "Comcast/Xfinity"
      },
      "North Lebanon Township": {
          Gas: "UGI Utilities",
          Trash: "Republic Services",
          Electric: "Met-Ed",
          Sewer: "North Lebanon Township Sewer Authority",
          Water: "North Lebanon Township Water Authority",
          Recycling: "Republic Services",
          WiFi: "Comcast/Xfinity"
      },
      "North Londonderry Township": {
          Gas: "UGI Utilities",
          Trash: "Waste Management",
          Electric: "Met-Ed",
          Sewer: "North Londonderry Township Sewer Authority",
          Water: "North Londonderry Township Water Authority",
          Recycling: "Waste Management",
          WiFi: "Verizon Fios"
      },
      "Palmyra Borough": {
          Gas: "UGI Utilities",
          Trash: "Weidle Sanitation Service",
          Electric: "Met-Ed",
          Sewer: "Palmyra Borough Sewer Authority",
          Water: "Palmyra Borough Water Authority",
          Recycling: "Weidle Sanitation Service",
          WiFi: "Comcast/Xfinity"
      },
      "Richland Borough": {
          Gas: "UGI Utilities",
          Trash: "Weidle Sanitation Service",
          Electric: "Met-Ed",
          Sewer: "Richland Borough Sewer Authority",
          Water: "Richland Borough Water Authority",
          Recycling: "Weidle Sanitation Service",
          WiFi: "Comcast/Xfinity"
      },
      "South Annville Township": {
          Gas: "UGI Utilities",
          Trash: "Greater Lebanon Refuse Authority",
          Electric: "Met-Ed",
          Sewer: "South Annville Municipal Authority",
          Water: "PA American Water",
          Recycling: "Greater Lebanon Refuse Authority",
          WiFi: "Comcast/Xfinity"
      },
      "South Lebanon Township": {
          Gas: "UGI Utilities",
          Trash: "Republic Services",
          Electric: "Met-Ed",
          Sewer: "South Lebanon Township Sewer Authority",
          Water: "South Lebanon Township Water Authority",
          Recycling: "Republic Services",
          WiFi: "Comcast/Xfinity"
      },
      "South Londonderry Township": {
          Gas: "UGI Utilities",
          Trash: "Waste Management",
          Electric: "Met-Ed",
          Sewer: "South Londonderry Township Sewer Authority",
          Water: "South Londonderry Township Water Authority",
          Recycling: "Waste Management",
          WiFi: "Verizon Fios"
      },
      "Swatara Township": {
          Gas: "UGI Utilities",
          Trash: "Republic Services",
          Electric: "Met-Ed",
          Sewer: "Swatara Township Sewer Authority",
          Water: "Swatara Township Water Authority",
          Recycling: "Republic Services",
          WiFi: "Comcast/Xfinity"
      },
      "Union Township": {
          Gas: "UGI Utilities",
          Trash: "Weidle Sanitation Service",
          Electric: "Met-Ed",
          Sewer: "Union Township Sewer Authority",
          Water: "Union Township Water Authority",
          Recycling: "Weidle Sanitation Service",
          WiFi: "Comcast/Xfinity"
      },
      "West Cornwall Township": {
          Gas: "UGI Utilities",
          Trash: "Weidle Sanitation Service",
          Electric: "Met-Ed",
          Sewer: "West Cornwall Township Sewer Authority",
          Water: "West Cornwall Township Water Authority",
          Recycling: "Weidle Sanitation Service",
          WiFi: "Comcast/Xfinity"
      },
      "West Lebanon Township": {
          Gas: "UGI Utilities",
          Trash: "Republic Services",
          Electric: "Met-Ed",
          Sewer: "West Lebanon Township Sewer Authority",
          Water: "West Lebanon Township Water Authority",
          Recycling: "Republic Services",
          WiFi: "Comcast/Xfinity"
      }
    },


    //Mifflin County
    Mifflin: {
      "Armagh Township": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Granville Township Sewer Authority",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "Bratton Township": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Granville Township Sewer Authority",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "Brown Township": {
          Gas: "UGI Utilities",
          Trash: "Parks Garbage Service",
          Electric: "Penelec",
          Sewer: "Granville Township Sewer Authority",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "Burnham Borough": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Lewistown Borough Sewer Office",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "Decatur Township": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Granville Township Sewer Authority",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "Derry Township": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Granville Township Sewer Authority",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "Granville Township": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Granville Township Sewer Authority",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "Juniata Terrace Borough": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Lewistown Borough Sewer Office",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "Kistler Borough": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Lewistown Borough Sewer Office",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "Lewistown Borough": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Lewistown Borough Sewer Office",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "McVeytown Borough": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Granville Township Sewer Authority",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "Menno Township": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Granville Township Sewer Authority",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "Newton Hamilton Borough": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Granville Township Sewer Authority",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "Oliver Township": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Granville Township Sewer Authority",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "Union Township": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Granville Township Sewer Authority",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      },
      "Wayne Township": {
          Gas: "UGI Utilities",
          Trash: "S&S Trash Service",
          Electric: "Penelec",
          Sewer: "Granville Township Sewer Authority",
          Water: "Mifflin County Municipal Authority",
          Recycling: "Mifflin County Solid Waste Authority",
          WiFi: "McM Internet / Centre WISP"
      }
    },


    //Northumberland County
    Northumberland: {
      "Augusta Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Coal Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Delaware Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "East Cameron Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "East Chillisquaque Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Herndon Borough": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Jackson Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Jordan Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Kulpmont Borough": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Lewis Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Little Mahanoy Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Lower Augusta Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Lower Mahanoy Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Marion Heights Borough": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "McEwensville Borough": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Milton Borough": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Mount Carmel Borough": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Mount Carmel Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Northumberland Borough": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Point Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Ralpho Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Riverside Borough": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Rockefeller Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Rush Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Shamokin": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Shamokin Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Snydertown Borough": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Sunbury": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Turbot Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Turbotville Borough": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Upper Augusta Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Upper Mahanoy Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Washington Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Watsontown Borough": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "West Cameron Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "West Chillisquaque Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Zerbe Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "Citizens' Electric Company",
          Sewer: "Sunbury Municipal Authority",
          Water: "Sunbury Municipal Authority",
          Recycling: "Sunbury Municipal Authority",
          WiFi: "Comcast/Xfinity"
      }
    },



    //Perry County
    Perry: {
      "Blain Borough": {
          Electric: "Penelec (800-545-7731)",
          "Water/Sewer": "Blain Borough (717-536-3333)",
          Trash: "CCD Trash bags available in the market",
          Gas: "Not available"
      },
      "Bloomfield Borough": {
          Electric: "PPL Electric Utilities (800-342-5775) or private vendor",
          "Trash/Sewer": "The Borough of Bloomfield",
          Water: "The New Bloomfield Water Authority (717-582-3382)",
          Gas: "Not available",
      },
      "Buffalo Township": {
          Electric: "PPL Electric Utilities (800-342-5775)",
          Sewer: "Private septic",
          Water: "Private well",
          Trash: "Private vendor",
          Gas: "Not available",
      },
      "Carroll Township": {
          Electric: "PPL Electric Utilities (800-342-5775)",
          Sewer: "Private septic",
          Water: "Private well",
          Trash: "Cocolamus Creek Disposal (717-463-2381), Sylvester's Services LLC (717-834-4976), or Waste Management (800-796-9696)",
          Gas: "Not available",
      },
      "Centre Township": {
          Electric: "PPL Electric Utilities (800-342-5775)",
          Sewer: "Private septic",
          Water: "Private well",
          Trash: "Sylvester's Services LLC (purchase bags at local grocery stores 717-834-4976)",
          Gas: "Not available"
      },
      "Duncannon Borough": {
          "Electric, Water, Sewer, and Trash": "All through Borough of Ducannon (717-834-4311)",
          Gas: "Not available"
      },
      "Greenwood Township": {
          Electric: "PPL Electric Utilities (800-342-5775)",
          Sewer: "Private septic",
          Water: "Private well",
          Trash: "Private vendor",
          Gas: "Not available"
      },
      "Howe Township": {
          Electric: "PPL Electric Utilities (800-342-5775)",
          Sewer: "Howe Township Municipal Authority (717-567-3905)",
          Water: "If public - Newport Borough Water Authority (717-567-6373), otherwise private well",
          Trash: "Private vendor",
          Gas: "Not available"
      },
      "Jackson Township": {
          Electric: "PPL Electric Utilities (800-342-5775)",
          Sewer: "Private septic",
          Water: "Private well",
          Trash: "Private vendor",
          Gas: "Not available"
      },
      "Juniata Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "PPL Electric Utilities",
          Sewer: "Juniata Township Municipal Authority",
          Water: "Juniata Township Municipal Authority",
          Recycling: "Juniata Township Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Landisburg Borough": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "PPL Electric Utilities",
          Sewer: "Landisburg Municipal Authority",
          Water: "Landisburg Municipal Authority",
          Recycling: "Landisburg Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Liverpool Borough": {
          Electric: "PPL Electric Utilities (800-342-5775)",
          "Water/Sewer": "Liverpool Municipal Authority (717-444-3521)",
          Trash: "Purchase CCD trash bags through the borough (717-444-3194)",
          Gas: "Not available"
      },
      "Liverpool Township": {
          Electric: "PPL Electric Utilities (800-342-5775)",
          "Water/Sewer": "Liverpool Municipal Authority (717-444-3521)",
          Trash: "Private vendor",
          Gas: "Not available"
      },
      "Marysville Borough": {
          Electric: "PPL Electric Utilities (800-342-5775)",
          "Sewer/Trash": "Marysville Borough (717-957-3110)",
          Water: "Veolia Water (888-299-8972)",
          Gas: "Not available"
      },
      "Miller Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "PPL Electric Utilities",
          Sewer: "Miller Township Municipal Authority",
          Water: "Miller Township Municipal Authority",
          Recycling: "Miller Township Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Millerstown Borough": {
          Electric: "PPL Electric Utilities (800-342-5775)",
          "Water/Sewer/Trash": "Millerstown Borough (717-589-3738)",
          Gas: "Not available"
      },
      "New Buffalo Borough": {
          Electric: "PPL Electric Utilities (800-342-5775)",
          Sewer: "New Buffalo Borough (717-395-2392)",
          Water: "Private well",
          Trash: "Paid through taxes",
          Gas: "Not available"
      },
      "Newport Borough": {
          Electric: "PPL Electric Utilities (800-342-5775)",
          Sewer: "Newport Sewer Authority (717-567-7005)",
          Water: "Newport Water Authority (717-567-6373)",
          Trash: "Private vendor",
          Gas: "Depends on address, call borough (717-567-6373)"
      },
      "Northeast Madison Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "PPL Electric Utilities",
          Sewer: "Northeast Madison Township Municipal Authority",
          Water: "Northeast Madison Township Municipal Authority",
          Recycling: "Northeast Madison Township Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Oliver Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "PPL Electric Utilities",
          Sewer: "Oliver Township Municipal Authority",
          Water: "Oliver Township Municipal Authority",
          Recycling: "Oliver Township Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Penn Township": {
          Electric: "PPL Electric Utilities (800-342-5775)",
          "Water/Sewer": "Penn Township Municipal Authority (717-834-6926)",
          Trash: "Private vendor",
          Recycling: "Sylvester's recycling bags available for purchase",
          Gas: "Call township to verify (717-834-5281)"
      },
      "Rye Township": {
          Electric: "PPL Electric Utilities (800-342-5775)",
          Sewer: "Private septic",
          Water: "If public - Veolia (866-439-2837), otherwise private well",
          Trash: "Penn Waste, managed through township",
          Gas: "Not available"
      },
      "Saville Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "PPL Electric Utilities",
          Sewer: "Saville Township Municipal Authority",
          Water: "Saville Township Municipal Authority",
          Recycling: "Saville Township Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Southwest Madison Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "PPL Electric Utilities",
          Sewer: "Southwest Madison Township Municipal Authority",
          Water: "Southwest Madison Township Municipal Authority",
          Recycling: "Southwest Madison Township Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Spring Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "PPL Electric Utilities",
          Sewer: "Spring Township Municipal Authority",
          Water: "Spring Township Municipal Authority",
          Recycling: "Spring Township Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Toboyne Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "PPL Electric Utilities",
          Sewer: "Toboyne Township Municipal Authority",
          Water: "Toboyne Township Municipal Authority",
          Recycling: "Toboyne Township Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Tuscarora Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "PPL Electric Utilities",
          Sewer: "Tuscarora Township Municipal Authority",
          Water: "Tuscarora Township Municipal Authority",
          Recycling: "Tuscarora Township Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Tyrone Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "PPL Electric Utilities",
          Sewer: "Tyrone Township Municipal Authority",
          Water: "Tyrone Township Municipal Authority",
          Recycling: "Tyrone Township Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Watts Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "PPL Electric Utilities",
          Sewer: "Watts Township Municipal Authority",
          Water: "Watts Township Municipal Authority",
          Recycling: "Watts Township Municipal Authority",
          WiFi: "Comcast/Xfinity"
      },
      "Wheatfield Township": {
          Gas: "UGI Utilities",
          Trash: "Hometown Disposal",
          Electric: "PPL Electric Utilities",
          Sewer: "Wheatfield Township Municipal Authority",
          Water: "Wheatfield Township Municipal Authority",
          Recycling: "Wheatfield Township Municipal Authority",
          WiFi: "Comcast/Xfinity"
      }
    },

    //Schuylkill County
    Schuylkill: {
      "Ashland Borough": {
          Gas: "UGI Utilities",
          Trash: "Anthracite Waste Services",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Auburn Borough": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Barry Township": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Blythe Township": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Branch Township": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Butler Township": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Cass Township": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Coaldale Borough": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Cressona Borough": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Deer Lake Borough": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Delano Township": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "East Brunswick Township": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "East Norwegian Township": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "East Union Township": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Eldred Township": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Frackville Borough": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Frailey Township": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Gilberton Borough": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Girardville Borough": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Gordon Borough": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Hegins Township": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Hubley Township": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Landingville Borough": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Mahanoy City Borough": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Mahanoy Township": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "McAdoo Borough": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Mechanicsville Borough": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Middleport Borough": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Schuylkill County Municipal Authority",
          Water: "Schuylkill County Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Minersville Borough": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Minersville Municipal Authority",
          Water: "Minersville Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Mount Carbon Borough": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Mount Carbon Municipal Authority",
          Water: "Mount Carbon Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "New Castle Township": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "New Castle Municipal Authority",
          Water: "New Castle Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "New Philadelphia Borough": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "New Philadelphia Municipal Authority",
          Water: "New Philadelphia Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "New Ringgold Borough": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "New Ringgold Municipal Authority",
          Water: "New Ringgold Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "North Manheim Township": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "North Manheim Municipal Authority",
          Water: "North Manheim Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "North Union Township": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "North Union Municipal Authority",
          Water: "North Union Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Norwegian Township": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Norwegian Township Municipal Authority",
          Water: "Norwegian Township Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Orwigsburg Borough": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Orwigsburg Municipal Authority",
          Water: "Orwigsburg Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Palo Alto Borough": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Palo Alto Municipal Authority",
          Water: "Palo Alto Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Pine Grove Borough": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Pine Grove Municipal Authority",
          Water: "Pine Grove Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Pine Grove Township": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Pine Grove Township Municipal Authority",
          Water: "Pine Grove Township Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Port Carbon Borough": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Port Carbon Municipal Authority",
          Water: "Port Carbon Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Port Clinton Borough": {
          Gas: "UGI Utilities",
          Trash: "GFL Environmental",
          Electric: "PPL Electric Utilities",
          Sewer: "Port Clinton Municipal Authority",
          Water: "Port Clinton Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Porter Township": {
          Gas: "UGI Utilities",
          Trash: "Blue Mountain Sanitation",
          Electric: "PPL Electric Utilities",
          Sewer: "Porter Township Municipal Authority",
          Water: "Porter Township Municipal Authority",
          Recycling: "Schuylkill County Recycling Program",
          WiFi: "Xfinity"
      },
      "Pottsville City": {
          Gas: "UGI Utilities",
          Trash: "Waste Management",
          Electric: "PPL Electric Utilities",
          Sewer: "Pottsville City Sewer Authority",
          Water: "Pottsville City Water Department",
          Recycling: "Pottsville City Recycling Program",
          WiFi: "Xfinity/Verizon Fios"
      }
    },

    //Snyder County
    Snyder: {
      "Adams Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Private Septic Systems",
          Water: "Private Wells",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Beaver Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Private Septic Systems",
          Water: "Private Wells",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Beavertown Borough": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Beavertown Municipal Authority",
          Water: "Beavertown Municipal Authority",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Center Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Private Septic Systems",
          Water: "Private Wells",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Chapman Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Private Septic Systems",
          Water: "Private Wells",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Franklin Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Private Septic Systems",
          Water: "Private Wells",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Freeburg Borough": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Freeburg Municipal Authority",
          Water: "Freeburg Municipal Authority",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Jackson Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Private Septic Systems",
          Water: "Private Wells",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "McClure Borough": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "McClure Municipal Authority",
          Water: "McClure Municipal Authority",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Middleburg Borough": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Middleburg Municipal Authority",
          Water: "Middleburg Municipal Authority",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Middlecreek Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Private Septic Systems",
          Water: "Private Wells",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Monroe Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Hummels Wharf Municipal Authority",
          Water: "Private Wells",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Penn Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Penn Township Municipal Authority",
          Water: "Penn Township Municipal Authority",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Perry Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Private Septic Systems",
          Water: "Private Wells",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Selinsgrove Borough": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Selinsgrove Municipal Authority",
          Water: "Selinsgrove Municipal Authority",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Shamokin Dam Borough": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Shamokin Dam Municipal Authority",
          Water: "Shamokin Dam Municipal Authority",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Spring Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Private Septic Systems",
          Water: "Private Wells",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Union Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Private Septic Systems",
          Water: "Private Wells",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "Washington Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Private Septic Systems",
          Water: "Private Wells",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "West Beaver Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Private Septic Systems",
          Water: "Private Wells",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      },
      "West Perry Township": {
          Gas: "UGI Penn Natural Gas",
          Trash: "Park's Garbage Service",
          Electric: "PPL Electric Utilities",
          Sewer: "Private Septic Systems",
          Water: "Private Wells",
          Recycling: "Park's Garbage Service",
          WiFi: "Verizon, EvenLink"
      }
    },

    //York County
    York: {
      "Carroll Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Chanceford Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Codorus Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Conewago Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Cross Roads Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Dallastown Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Dallastown/Yoe Water Authority",
      Water: "Dallastown/Yoe Water Authority",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Delta Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Delta Municipal Waterworks",
      Water: "Delta Municipal Waterworks",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Dillsburg Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Dillsburg Borough Authority",
      Water: "Dillsburg Borough Authority",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Dover Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Dover Borough Water System",
      Water: "Dover Borough Water System",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Dover Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Dover Township Sewer Authority",
      Water: "Dover Township Water",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "East Hopewell Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "East Manchester Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "East Prospect Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Fairview Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Fawn Grove Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Fawn Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Felton Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Franklin Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Franklintown Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Franklintown Borough Municipal Authority",
      Water: "Franklintown Borough Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Glen Rock Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Glen Rock Water Authority",
      Water: "Glen Rock Water Authority",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Goldsboro Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Goldsboro Borough Water Company",
      Water: "Goldsboro Borough Water Company",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Hallam Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Hallam Borough",
      Water: "Hallam Borough",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Hanover Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Hanover Borough",
      Water: "Hanover Borough",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Heidelberg Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Hellam Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Hopewell Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Jackson Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Jackson Township Sewer Authority",
      Water: "The York Water Company",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Jacobus Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Jefferson Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Lewisberry Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Loganville Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Lower Chanceford Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Lower Windsor Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Manchester Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Manchester Municipal Authority",
      Water: "Manchester Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Manchester Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Manheim Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Monaghan Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Mt Wolf Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Mt Wolf Municipal Authority",
      Water: "Mt Wolf Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "New Freedom Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "New Freedom Municipal Authority",
      Water: "New Freedom Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "New Salem Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "New Salem Municipal Authority",
      Water: "New Salem Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Newberry Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "North Codorus Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "North Hopewell Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "North York Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "North York Municipal Authority",
      Water: "North York Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Paradise Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Peach Bottom Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Private Septic Systems",
      Water: "Private Wells",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Penn Township": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Penn Township Municipal Authority",
      Water: "Penn Township Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    },
    "Railroad Borough": {
      Gas: "UGI Penn Natural Gas",
      Trash: "Penn Waste",
      Electric: "PPL Electric Utilities",
      Sewer: "Railroad Borough Municipal Authority",
      Water: "Railroad Borough Municipal Authority",
      Recycling: "Penn Waste",
      WiFi: "Verizon, Comcast/Xfinity"
    }
  }
};


export default municipalityData;